export const PAYMENT_METHOD_CARD = 'stripe'
export const PAYMENT_METHOD_IDEAL = 'ideal'
export const PAYMENT_METHOD_BANK_TRANSFER = 'bank-transfer'
export const PAYMENT_METHOD_MERCADO_PAGO = 'mercado-pago'
export const PAYMENT_METHOD_P24 = 'p24'

export const PAYMENT_SUCCESS = 'success'
export const PAYMENT_FAILURE = 'failure'
export const PAYMENT_PENDING = 'pending'
export const PAYMENT_STATUS = [PAYMENT_SUCCESS, PAYMENT_FAILURE, PAYMENT_PENDING]


export const userCTA = {
    NONE: 'none',
    SUPPORT: 'support',
    FACE_CHECKIN: 'face-checkin'
}